import React, { useEffect, useState } from "react";
import TaiwanIcon from "../../../assets/images/Icons/Taiwan.svg";
import CambodiaIcon from "../../../assets/images/Icons/Cambodia.svg";
import GrabpoolsIcon from "../../../assets/images/Icons/Grabpools.svg";
import ChinaIcon from "../../../assets/images/Icons/China.svg";
import SydneyIcon from "../../../assets/images/Icons/Sydney.svg";
import MangoliaIcon from "../../../assets/images/Icons/Mongolia.svg";
import SingaporeIcon from "../../../assets/images/Icons/Singapore.svg";
import JapanIcon from "../../../assets/images/Icons/Japan.svg";
import HongkongIcon from "../../../assets/images/Icons/Hongkong.svg";
import NusantaraIcon from "../../../assets/images/Icons/Nusantara.svg";
import DownArrow from "../../../../src/assets/images/Icons/down_arrow.svg";
import UpArrow from "../../../../src/assets/images/Icons/up_arrow.svg";
import LeftArrow from "../../../../src/assets/images/Icons/icons/left_arrow.svg";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import LoaderImg from "../../../../src/assets/images/Icons/ajax-loader.svg"
import {
  makeAjax,
  respStatus,
  showMessage,
  url,
} from "../../../helpers/global_helper";
import { useNavigate } from "react-router-dom";
import { pageNumberInfo, setTotalNoResult } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { MdOutlineArrowBackIos } from "react-icons/md";
import ErrorInnerPopup from "../../Popups/ErrorInnerPopup";
import ErrorPopup from "../../Popups/ErrorPopup";
import PaginationResult from "../../LobbyContent/SubComponents/PaginationResult";
import TwoDBackResult from "./ResultComponents/TwoDBackResult";
import BigSmallResult from "./ResultComponents/BigSmallResult";
import ColokJituResult from "./ResultComponents/ColokJituResult";
import DasarBigSmallResult from "./ResultComponents/DasarBigSmallResult";
import DasarOddEvenResult from "./ResultComponents/DasarOddEvenResult";
import OddEvenResult from "./ResultComponents/OddEvenResult";
import KembangKempisResult from "./ResultComponents/KembangKempisResult";
import ShioResult from "./ResultComponents/ShioResult";
import SilangHomoResult from "./ResultComponents/SilangHomoResult";
import TengahTepiResult from "./ResultComponents/TengahTepiResult";

const Accordion = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [last10Result, setLast10Result] = useState([]);
  const pageNumber = useSelector((state) => state.paginationData.pageNumber);
  // const perPage = useSelector((state) => state.paginationData.dataInOnePage);
  const perPage = useSelector((state) => state.paginationData.dataInOnePageResult);

  const [activeTab, setActiveTab] = useState(0);
  const [dropdownActive, setDropdownActive] = useState(false);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const country_name = useSelector((state) => state.CommonConfig.country_name);
  const [fromDate, setFromDate] = useState("");
  const [maxUntilDate, setMaxUntilDate] = useState("");
  const [untilDate, setUntilDate] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessages, setErrorMessages] = useState('');
  const [result, setResult] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [refreshResults, setRefreshResults] = useState(false); // New state to trigger useEffect
  const [myData, setMyData] = useState();
  const [submitted, setSubmitted] = useState(false); // Track if submit was clicked
  const [currentPage, setCurrentPage] = useState();
  const [resetPage, setResetPage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState('number'); // Set initial tab here
  const [submitTrigger, setSubmitTrigger] = useState(0);
  const [pageCall, setPageCall] = useState(false);

  const countrylist = {
    Taiwan: TaiwanIcon,
    Grabpools: GrabpoolsIcon,
    Cambodia: CambodiaIcon,
    Singapore: SingaporeIcon,
    Japan: JapanIcon,
    China: ChinaIcon,
    Sydney: SydneyIcon,
    Mongolia: MangoliaIcon,
    Hongkong: HongkongIcon,
    Nusantara: NusantaraIcon,
  };

  const today = new Date();
  const maxToday = today.toISOString().split("T")[0]; // Today's date in YYYY-MM-DD format

  useEffect(() => {
    if (selected !== 'number') {
      setUntilDate('');
      setFromDate('');
      setResult('');
    }
  }, [selected])



  const handleFromDateChange = (e) => {
    const selectedFromDate = e.target.value;
    setFromDate(selectedFromDate);
    setMaxUntilDate("");
  };

  useEffect(() => {
  }, [last10Result, untilDate, fromDate, myData])

  // Function to reset the `resetPage` state back to false
  const handleResetPageNo = () => {
    setResetPage(false);
  };

  const handlePaginationChange = (newPage) => {
    setCurrentPage(newPage);
    // fetchData(newPage);
  };

  const handleResultChange = (e) => {
    const input = e.target.value;

    if (/^\d*$/.test(input)) {
      setResult(input);
    }
  };

  useEffect(() => {
    setSubmitted(false);
    setFromDate('')
    setUntilDate('')
    setResetPage(true);
    setResult('');
    dispatch(pageNumberInfo(1))
    fetchData()

  }, [country_name, selected]);
  
  const locale = props.i18n.language;

  const handleDropdownClick = () => {
    setActiveTab(10); // Set the last tab (Dropdown Tab) as active
    setDropdownActive(!dropdownActive); // Toggle dropdown visibility
  };

  useEffect(() => {
    setLast10Result([]);
    if(selected === 'number' && submitTrigger === 0) {
      makeAjax(
        url.TOGEL_API.getResultTogelNew,
        {
          gameId: gameId,
          startDate: '',
          endDate: '',
          number: '',
          length: 30
        },
        url.TOGEL_MS_EXT
      ).then((response) => {
        if (response.code === "data_not_found") {
          setLast10Result([]);
          return;
        }
        setLast10Result(response.data.data);
        dispatch(setTotalNoResult(response.data.total));
      });
    }
  }, [gameId, selected]);


  useEffect(() => {
    if(selected=== "number" && submitTrigger === 0){
      setLast10Result([]);
      makeAjax(
        url.TOGEL_API.getResultTogelNew,
        {
          gameId: gameId,
          startDate: '',
          endDate: '',
          number: '',
          length: 30
        },
        url.TOGEL_MS_EXT
      ).then((response) => {
        if (response.code === "data_not_found") {
          setLast10Result([]);
          dispatch(setTotalNoResult(1));

          return;
        }
        setLast10Result(response.data.data);
        dispatch(setTotalNoResult(response.data.total));
      });
    }
  }, [selected]);

  useEffect(() => {
    setLast10Result([]);
    setResult('')
    if(selected === 'number') {
      makeAjax(
        url.TOGEL_API.getResultTogelNew,
        {
          gameId: gameId,
          startDate: submitTrigger ? fromDate : '' ,
          endDate: submitTrigger ? untilDate :'',
          number: result || '',
          page: pageNumber,
          length: 30
        },
        url.TOGEL_MS_EXT
      ).then((response) => {
        if (response.code === "data_not_found") {
          setLast10Result([]);
          return;
        }
        // setSubmitTrigger(0);
        setLast10Result(response.data.data);
        dispatch(setTotalNoResult(response.data.total));
      });
    }
  }, [perPage, pageNumber]);

  const fetchData=()=>{
    setLast10Result([]);
    makeAjax(
      url.TOGEL_API.getResultTogelNew,
      {
        gameId: gameId,
        startDate: '',
        endDate: '',
        number: '',
        length: 30
      },
      url.TOGEL_MS_EXT
    ).then((response) => {
      if (response.code === "data_not_found") {
        setLast10Result([]);
        return;
      }
      setLast10Result(response.data.data);
      dispatch(setTotalNoResult(response.data.total));
    });
}

  const fetchNumberResults = () => {
    makeAjax(
      url.TOGEL_API.getResultTogelNew,
      {
        gameId: gameId,
        startDate: fromDate,
        endDate: untilDate,
        number: result,
        length: 30
      },
      url.TOGEL_MS_EXT
    ).then((response) => {
      if (response.status === respStatus["ERROR"] && response.messages.includes("Data Not Found")) {
        setLast10Result([]);
        dispatch(setTotalNoResult(1));
      } else {
        setLast10Result(response.data.data);
        setShowResults(true);
        dispatch(setTotalNoResult(response.data.total));
      }
      setSubmitted(true);
      setResetPage(true);
      setLoading(false);
    }).catch(() => {
      setLoading(false); // Stop loading on error
    });
  }

  const handleSubmit = (e) => {
    setLast10Result([]);
    // Only call preventDefault if handleSubmit is triggered by an event
    if (e) e.preventDefault();

    setShowErrorPopup(false);
    setShowResults(false);
    setLast10Result([]);

    if ((fromDate && !untilDate) || (!fromDate && untilDate)) {
      setErrorMessages("Please fill in both 'From' and 'Until' dates.");
      setShowErrorPopup(true);
      return;
    }

    // Check that result length is between 2 and 4 digits if a result is provided
    if (result && (result.length < 2 || result.length > 4)) {
      setErrorMessages("Result should be between 2 and 4 digits.");
      setShowErrorPopup(true);
      return;
    }
    if (selected === "number") {
      setSubmitTrigger(1); 
      fetchNumberResults()
    }else if (selected === "2dback") {
      setSubmitTrigger(1);
    }else if (selected === "bigsmall") {
      setSubmitTrigger(1);
    }else if (selected === "oddeven") {
      setSubmitTrigger(1); 
    }else if (selected === "colokjitu") {
      setSubmitTrigger(1); 
    }else if (selected === "dasarbigsmall") {
      setSubmitTrigger(1); 
    }else if (selected === "dasaroddeven") {
      setSubmitTrigger(1); 
    }else if (selected === "kembangkempis") {
      setSubmitTrigger(1); 
    }else if (selected === "shio") {
      setSubmitTrigger(1); 
    }else if (selected === "silanghomo") {
      setSubmitTrigger(1); 
    }else if (selected === "tengahtapi") {
      setSubmitTrigger(1); 
    }
  };

    const getTranslatedDay = (day) => {
      switch (day.toLowerCase()) {
        case "monday":
          return props.t('monday');
        case "tuesday":
          return props.t('tuesday');
        case "wednesday":
          return props.t('wednesday');
        case "thursday":
          return props.t('thursday');
        case "friday":
          return props.t('friday');
        case "saturday":
          return props.t('saturday');
        case "sunday":
          return props.t('sunday');
        default:
          return day;
      }
    };  

const handleTrigger = () => {
  setSubmitTrigger(0);
}

const pageCallFunction=()=>{
  setPageCall(true)
}

 const prize123Status = useSelector((state) => state.CommonConfig.discount.prize123Status);
  return (
    <div className="accordion_wrapper result_page">
      <div className="result-wrapper">
        <div className="pages_topbar">
          <div className="back_arrow" onClick={() => navigate("/")}>
            <MdOutlineArrowBackIos />
          </div>
          <div className="page_heading">
            <h2>
              {props.t("result")} & {props.t("analysis")}
            </h2>
          </div>
        </div>

        <div class="form-container result-page">
          <form onSubmit={handleSubmit} className="inline-form" autoComplete="off">
            <div className="form-group">
              <label>{props.t('from')}:
              </label>
              <input
                type="date"
                name="from"
                value={fromDate}
                onChange={handleFromDateChange}
                max={maxToday} // Set maximum 'From' date as today's date
              />
            </div>
            <div className="form-group">
              <label>{props.t('until')}</label>

              <input
                type="date"
                name="until"
                value={untilDate}
                onChange={(e) => setUntilDate(e.target.value || "")}
                min={fromDate || ""}
                max={maxToday}
              />
            </div>
            <div>
              <div className="from-group reslt-ipt">
                <label>{props.t('result')}:</label>
                <input
                  type="text"
                  name="result"
                  value={result}
                  onChange={handleResultChange}
                  maxLength="4"
                  disabled={selected !== "number"}
                />
              </div>
            </div>
            {/* <input type="submit" value="Search" /> */}
            <input type="submit" value={props.t('search')} />
          </form>
        </div>
      </div>

      <div className="result-category">
        <div className="game-tabs">
          <div className="tabs-container">
            <div className="tabs-header">
              <div
                className={`tab-item ${selected === 'number' ? 'active' : ''}`}
                onClick={() => {
                  setSelected('number');
                  setSubmitTrigger(0);
              }}
              >
                {props.t('number')}
              </div>
              <div
                className={`tab-item ${selected === '2dback' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('2dback');
                  setSubmitTrigger(0);
                  setPageCall(false);
              }}
              >
                {props.t('2D_back')}
              </div>
              <div
                className={`tab-item ${selected === 'bigsmall' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('bigsmall')
                  setSubmitTrigger(0);
                }}
              >
                {props.t('big')}/{props.t('small')}
              </div>
              <div
                className={`tab-item ${selected === 'oddeven' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('oddeven')
                  setSubmitTrigger(0);
                }}
              >
                {props.t('odd')}/{props.t('even')}
              </div>
              <div
                className={`tab-item ${selected === 'colokjitu' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('colokjitu')
                  setSubmitTrigger(0);
                }}
              >
                Colok Jitu
              </div>
              <div
                className={`tab-item ${selected === 'dasarbigsmall' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('dasarbigsmall')
                  setSubmitTrigger(0);
                }}
              >
                Dasar {props.t('big')}/{props.t('small')}
              </div>
              <div
                className={`tab-item ${selected === 'dasaroddeven' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('dasaroddeven')
                  setSubmitTrigger(0);
                }}
              >
                Dasar {props.t('odd')}/{props.t('even')}
              </div>
              <div
                className={`tab-item ${selected === 'kembangkempis' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('kembangkempis')
                  setSubmitTrigger(0);
                }}
              >
                Kembang/Kempis
              </div>
              <div
                className={`tab-item ${selected === 'shio' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('shio')
                  setSubmitTrigger(0);
                }}
              >
                Shio
              </div>
              <div
                className={`tab-item ${selected === 'silanghomo' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('silanghomo')
                  setSubmitTrigger(0);
                }}
              >
                Silang Homo
              </div>
              <div
                className={`tab-item ${selected === 'tengahtapi' ? 'active' : ''}`}
                onClick={() => {
                  setFromDate('')
                  setUntilDate('');
                  setSelected('tengahtapi')
                  setSubmitTrigger(0);
                }}
              >
                Tengah/Tepi
              </div>
            </div>

            <div className="tab-content">
              {selected === 'number' && (
                <>
                  <div className="data-analysis">
                    <div className="cate-heading">
                      <h2>{country_name} {props.t('number')} Data {props.t('analysis')}</h2>
                    </div>
                    <div className="container data-table">
                      <table>
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>{props.t('day')}</th>
                            <th>{props.t('date')}</th>
                            <th>{props.t('result')}</th>
                            {prize123Status === 1 && <th>{props.t('result')}2</th>}
                            {prize123Status === 1 && <th>{props.t('result')}3</th>}  
                          </tr>
                        </thead>
                        <tbody>
                          {last10Result && last10Result !== undefined && last10Result.length > 0 ? (
                            last10Result.map((result, index) => {
                              const date = new Date(result.datetime);
                              const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
                              const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
                              const translatedDay = getTranslatedDay(dayName);
          
                              return (
                                <tr
                                  key={result.period}
                                  className={index % 2 === 0 ? "even-row" : "odd-row"}
                                >
                                  <td>{index + 1}</td>
                                  {/* <td>
                                    {date.toLocaleDateString("en-US", { weekday: "long" })}
                                  </td> */}
                                  <td>{translatedDay}</td>
                                  <td>{formattedDate}</td>
                                  <td>{result.number}</td>
                                  {prize123Status === 1 && <td>{result.number2}</td>}
                                  {prize123Status === 1 && <td>{result.number3}</td>}  
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="4">No results found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      <PaginationResult resetPage={resetPage} handleResetPageNo={handleResetPageNo} />
                    </div>
                  </div>
                </>)}
              {selected == '2dback' && <TwoDBackResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
              {selected === 'bigsmall' && <BigSmallResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
              {selected === 'colokjitu' && <ColokJituResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
              {selected === 'dasarbigsmall' && <DasarBigSmallResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
              {selected === 'dasaroddeven' && <DasarOddEvenResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
              {selected === 'oddeven' && <OddEvenResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
              {selected === 'kembangkempis' && <KembangKempisResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
              {selected === 'shio' && <ShioResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
              {selected === 'silanghomo' && <SilangHomoResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
              {selected === 'tengahtapi' && <TengahTepiResult startDate={fromDate} endDate={untilDate} submitTrigger={submitTrigger} checkSelected={selected} setSubmitTrigger = {handleTrigger} pageCall={pageCall} pageCallFunction={pageCallFunction}/>}
            </div>
          </div>
        </div>
      </div>

      {showErrorPopup && (
        <ErrorInnerPopup
          modalTitle={""}
          modalHeader={true}
          onCloseModal={() => setShowErrorPopup(false)}
        >
          <ErrorPopup
            message={errorMessages}
            onClose={() => setShowErrorPopup(false)}
          />
        </ErrorInnerPopup>
      )}

      {loading && (
        <div className="loader-background">
          <div className="ajax_loader_container">
            <img src={LoaderImg} alt="Loading..." />
          </div>
        </div>
      )}
    </div>
  );
};


export default withTranslation()(Accordion);





